import React from "react";
import { string } from "prop-types";

const RightArrowButton = ({
  color = "#4785ff",
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.047 65.61" width="60" height="60">
    <g>
      <path fill="#FFFFFF" d="M6.62,4.243c0.768,0,1.535,0.293,2.121,0.879l27.686,27.682L8.741,60.489c-1.172,1.171-3.07,1.171-4.242,0
        c-1.172-1.171-1.172-3.071,0-4.243l23.443-23.442L4.5,9.364c-1.172-1.171-1.172-3.07,0-4.242C5.084,4.536,5.853,4.243,6.62,4.243z"
        />
    </g>
  </svg>
);

RightArrowButton.propTypes = {
  color: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export default RightArrowButton;
